module.exports = __webpack_public_path__ + "static/shipkoo-express-2-273afdb0e169534741c947ac5abb53e2.png";